import React from 'react';
import type { FacetHandlerProps, SearchResult } from '../../../types';
import { Typeahead as SyncTypeahead } from 'react-bootstrap-typeahead';
import { toArray } from '../../../utils/misc';
import 'react-bootstrap-typeahead/css/Typeahead.css';

export default function Typeahead(
  props: FacetHandlerProps<SearchResult, { id: string; name: string }>
): JSX.Element {
  const { facet, filters } = props;
  const data = toArray(facet.value ?? []);
  const selected = filters[facet.index]?.toString() ?? '';
  const id = facet.label
    .split(' ')
    .map(l => {
      // preserve initialisms
      return l.toUpperCase() === l
        ? l
        : // lowercase words
          l.toLowerCase();
    })
    .join(' ');

  return (
    <div id={id} className="form-group">
      <label htmlFor={id}>{facet.label}</label>
      <SyncTypeahead
        id={id}
        value={selected}
        multiple
        maxResults={400}
        paginate={false}
        clearButton
        onInputChange={(search: string) => {
          if (search === '') {
            props.onChange(facet.index, null);
          }
        }}
        onChange={(items: any[]) => {
          const res = items.map(i => i.id);
          props.onChange(facet.index, res.length ? res : null);
        }}
        labelKey="name"
        placeholder={`Search by ${id}...`}
        options={data ?? []}
      />
    </div>
  );
}
